/* Homepage PRODUCTS carousel: autoplay every 6s (2 cards at a time) +
   prev/next arrows that fade in on hover. Pure native scroll — relies on
   the scroll-snap-type already set in CSS for the snap behaviour.
   Manual arrow clicks clamp at both ends (no wrap-around — confusing UX).
   The autoplay resets to the start with an instant jump when it reaches
   the end so the loop is invisible between ticks. */
(function () {
  function init() {
    const carousel = document.querySelector('.popular-products-section .popular-products__wrapper');
    if (!carousel || carousel.dataset.muvCarouselBound === 'true') return;
    carousel.dataset.muvCarouselBound = 'true';

    const host = carousel.parentElement;
    host.style.position = 'relative';

    function makeArrow(direction) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'muv-carousel-arrow muv-carousel-arrow--' + direction;
      btn.setAttribute('aria-label', direction === 'prev' ? 'Previous' : 'Next');
      const chevron = direction === 'prev'
        ? '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 2L4 7L9 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 2L10 7L5 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.innerHTML = chevron;
      return btn;
    }
    const prev = makeArrow('prev');
    const next = makeArrow('next');
    host.appendChild(prev);
    host.appendChild(next);

    function cardStep() {
      const firstCard = carousel.querySelector('.popular-products__item');
      if (!firstCard) return 300;
      const gap = parseFloat(getComputedStyle(carousel).columnGap || getComputedStyle(carousel).gap || 0) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    function scrollByCards(n) {
      const step = cardStep();
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      const target = Math.max(0, Math.min(maxScroll, carousel.scrollLeft + step * n));
      carousel.scrollTo({ left: target, behavior: 'smooth' });
    }
    function autoplayTick() {
      if (paused) return;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      // Reached the end → reset to the start without smooth scroll so it
      // doesn't look like a confusing wrap-around. Next tick continues
      // moving forward from index 0.
      if (carousel.scrollLeft >= maxScroll - 4) {
        carousel.scrollTo({ left: 0, behavior: 'auto' });
        return;
      }
      scrollByCards(2);
    }

    prev.addEventListener('click', function () { scrollByCards(-2); pause(); });
    next.addEventListener('click', function () { scrollByCards(2); pause(); });

    // Autoplay
    const AUTOPLAY_MS = 6000;
    const RESUME_MS = 8000;
    let autoplayId = null;
    let paused = false;
    let resumeTimeoutId = null;

    function start() {
      if (autoplayId) return;
      autoplayId = setInterval(autoplayTick, AUTOPLAY_MS);
    }
    function stop() {
      if (autoplayId) { clearInterval(autoplayId); autoplayId = null; }
    }
    function pause() {
      paused = true;
      clearTimeout(resumeTimeoutId);
      resumeTimeoutId = setTimeout(function () { paused = false; }, RESUME_MS);
    }

    host.addEventListener('mouseenter', function () { paused = true; });
    host.addEventListener('mouseleave', function () { paused = false; });
    carousel.addEventListener('touchstart', function () { paused = true; }, { passive: true });

    // Disable autoplay if user prefers reduced motion
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // arrows stay, but no autoplay
    } else {
      start();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
